import { Check, Circle, CircleDot } from "lucide-react";

export function ChapterStatusItem({
  label,
  state,
  onClick,
  title,
}: {
  label: React.ReactNode;
  state: "done" | "current" | "pending";
  onClick?: () => void;
  title?: string;
}) {
  const Icon = state === "done" ? Check : state === "current" ? CircleDot : Circle;
  const content = (
    <>
      <span className="chapter-status" aria-hidden="true">
        <Icon size={14} />
      </span>
      <span className="chapter-meta">{label}</span>
    </>
  );
  if (!onClick) {
    return <li className={`chapter-item ${state}`}>{content}</li>;
  }
  return (
    <li className={`chapter-item ${state}`}>
      <button type="button" className="chapter-item-btn" onClick={onClick} title={title}>
        {content}
      </button>
    </li>
  );
}
